import React, { Component } from 'react'; 
import { Link } from 'react-router-dom';
class Palabra extends Component{ 
    componentDidMount(){
    window.startx();
  }
    render(){ 
        return (
          <div id="main" className="wrapper style1">
            <div className="container">
              <header className="major">
                <h2>Encuentra la Palabra</h2>
              </header>
              <span className="containerjuego">
          <div className="content">
            <div>
            <h2>
             <iframe  src = "https://playpager.com/embed/wordpuzzle/index.html" title="Encuentra la Palabra" width="1080" height="720"></iframe>
            </h2>
            </div>
        
          </div>
            <div>
            <div className="containerjuego">
            <Link className="button" to="/juego"> 
                Regresar
              </Link>
            </div>
            </div>
            </span>
          </div>
          </div>
          );
    } 
} 

export default Palabra;